import React, { FC } from 'react'
import { LoadingBar, Flex } from '@components/gassan-ui'
import { motion } from 'framer-motion'
import { Parent } from './elements'

const LoadingRow: FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      <Parent
        pb={{ _: '1rem', medium: '1.75rem', large: '2rem' }}
        mb={{ _: '1rem', medium: '1.75rem', large: '2rem' }}
      >
        <LoadingBar width="100%" height={{ _: '3.75rem', small: '10.5rem', large: '11rem' }} />
        <Flex flexDirection="column">
          <Flex justifyContent="space-between" mb={{ _: '1rem', large: '1.5rem' }}>
            <LoadingBar width={['60%', '30%']} height={{ _: '1.5rem', small: '1.75rem' }} />
            <LoadingBar
              display={['block', 'none']}
              width={['2rem', '100%']}
              height={{ _: '1.5rem', small: '1.75rem' }}
            />
          </Flex>
          <LoadingBar
            width={{ _: '30%', small: '8.5rem', xlarge: '12.5rem' }}
            height={{ _: '1rem', small: '1.5rem' }}
            mb={{ _: '0.5rem', large: '1rem' }}
          />
          <Flex mt={{ small: 'auto', large: 'initial' }}>
            <LoadingBar
              display={{ _: 'none', small: 'flex' }}
              width="7rem"
              mr="2.5rem"
              height="1.5rem"
              mb="0.5rem"
            />
            <LoadingBar
              display={{ _: 'none', small: 'flex' }}
              width="7rem"
              height="1.5rem"
              mb="0.5rem"
            />
          </Flex>
          <LoadingBar
            display={['block', 'none']}
            width={{ _: '20%' }}
            height={{ _: '1rem' }}
            mb={{ _: '1rem' }}
          />
          <LoadingBar
            display={['block', 'none']}
            width={{ _: '20%' }}
            height={{ _: '1rem' }}
            mb={{ _: '1rem' }}
          />
        </Flex>
        <LoadingBar
          display={['none', 'flex']}
          justifySelf="flex-end"
          width={{ _: '6rem', xlarge: '100%' }}
          height={{ _: '1.5rem', small: '1.75rem' }}
        />
      </Parent>
    </motion.div>
  )
}

export default LoadingRow
